import Tippy from '@tippyjs/react';
import { Dispatch, SetStateAction, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { createSearchParams, Link, useNavigate, useSearchParams } from 'react-router-dom';
import { ReactComponent as HeadingCatalogProducer } from '../assets/svg/Catalog.svg';
import { ReactComponent as Order } from '../assets/svg/content/action-order.svg';
import { ReactComponent as StatusDl } from '../assets/svg/content/status-dl.svg';
import { ReactComponent as Fav } from '../assets/svg/content/status-fav.svg';
import { ReactComponent as StatusViewAll } from '../assets/svg/content/status-view-all.svg';
import { ReactComponent as Grid } from '../assets/svg/controls-catalog-grid.svg';
import { ReactComponent as List } from '../assets/svg/controls-catalog-list.svg';
import { ReactComponent as Download } from '../assets/svg/Download.svg';
import { ReactComponent as Filter } from '../assets/svg/filter.svg';
import { ReactComponent as HeadingCatalog } from '../assets/svg/heading-catalog.svg';
import { ReactComponent as New } from '../assets/svg/New.svg';
import {
    ACCESS_TYPES,
    AccessResponse,
    ContentTVUnit,
    ContentType,
    ContentUnit,
    PERMISSIONS,
    TYPS,
    useAccessRequestUnitMutation,
    UsedBooks,
    useEditContentUnitMutation,
    useEditTVUnitMutation,
    useGetAccessRequestsQuery,
    useGetMediaHeaderMutation,
    useGetMediaUsedBookQuery,
    useGetMetaDataMutation,
    useGetTVUsedBookQuery,
    useLazyGetCheckedContentQuery,
    useLazyGetCheckedTVQuery,
    useLazyGetContentTVListCountQuery,
    useLazyGetContentUnitListCountQuery,
    useLazyGetContentUnitListQuery,
    useLazyGetContentUnitMediaQuery,
    useLazyGetNewMediaQuery,
    useLazyGetNewTVQuery,
    useLazyGetOffersMediaQuery,
    useLazyGetOffersTVQuery,
    useLazyGetTVListQuery
} from '../services/content_v1';
// import { ReactComponent as StatusViewNone } from '../assets/svg/content/status-view-none.svg';
import saveAs from 'file-saver';
import ReactDOM from 'react-dom';
import { ReactComponent as StatusProcuderEdit } from '../assets/svg/content/status-producer-edit.svg';
import { ReactComponent as StatusProcuderHidden } from '../assets/svg/content/status-producer-hidden.svg';
import { ReactComponent as StatusProcuderOk } from '../assets/svg/content/status-producer-ok.svg';
import { ReactComponent as StatusProcuderPendind } from '../assets/svg/content/status-producer-pending.svg';
import { ReactComponent as StatusProcuderUsers } from '../assets/svg/content/status-producer-users.svg';
import { ReactComponent as StatusProcuderVip } from '../assets/svg/content/status-producer-vip.svg';
import { ReactComponent as StatusProcuderVisible } from '../assets/svg/content/status-producer-visible.svg';
import { extractErrorDetail, isProvider, ROLE, useIsConsumer, useIsGuest, useIsPartnerSource, ymHit } from '../components/common';
import Button from '../components/mplat/Button/Button';
import { CatalogGrid } from '../components/mplat/CatalogGrid';
import { CheckBox } from '../components/mplat/CheckBox';
import Content from '../components/mplat/Content';
import { ContentItemInfo } from '../components/mplat/ContentList/ContentItemInfo';
import { ContentTVItemInfo } from '../components/mplat/ContentList/ContentTVItemInfo';
import { ContentTVOrderModal } from '../components/mplat/ContentList/ContentTVOrderModal';
import ContentTV from '../components/mplat/ContentTV';
import Table from '../components/mplat/DataTable/Table';
import TableBody from '../components/mplat/DataTable/TableBody';
import { TableColumn } from '../components/mplat/DataTable/TableColumn';
import TableHeader from '../components/mplat/DataTable/TableHeader';
import { TableHeaderColumn } from '../components/mplat/DataTable/TableHeaderColumn';
import TableListName from '../components/mplat/DataTable/TableListName';
import TableRow from '../components/mplat/DataTable/TableRow';
import ImageLoader from '../components/mplat/ImageLoader';
import MainContentFilter from '../components/mplat/MainContentFilter';
import MainHeader from '../components/mplat/MainHeader';
import MobileFilter from '../components/mplat/MobileFilter';
import { MobileFilterItem } from '../components/mplat/MobileFilterItem';
import { ErrorModal } from '../components/mplat/Modals/ErrorModal';
import { SendModal } from '../components/mplat/Modals/SendModal';
import MultiSelect from '../components/mplat/MultiSelect';
import { Searcher } from '../components/mplat/Searcher';
import Select from '../components/mplat/Select';
import { SelectButton } from '../components/mplat/SelectButtonSpan';
import { Spinner } from '../components/mplat/Spinner';
import { Switch } from '../components/mplat/Switch';
import { useAuth, useLanguage, useRole } from '../hooks';
import EmptyPng from '../img/empty.png';
import { OffsetLimit, StatusPagesResponse } from '../services/api';
import { BASE_URL } from '../services/reauth';
import { AccessRequestStatus } from '../services/users_v1';

const PAGE_SIZE = 36;


function statusToBadge(status: {
    id: number,
    account_id: number,
    status: AccessRequestStatus
}[]) {
    switch (status.at(0)?.status) {
        case AccessRequestStatus.OPEN:
        case AccessRequestStatus.PENDING:
            return <span className="">
                <span className="status-ok">
                    <Trans>Ordered</Trans>
                </span>
            </span>
        case AccessRequestStatus.REJECTED:
            return <span className="" style={{ borderColor: 'var(--c-red)', background: 'transparent', cursor: 'auto' }}>
                <span style={{ color: 'var(--c-red)' }}>
                    <Trans>Rejected</Trans>
                </span>
            </span>
        case AccessRequestStatus.GRANTED:
            return <span className="">
                <span className="status-ok">
                    {/* <OK /> */}
                    <Trans>Granted</Trans>
                </span>
            </span>
        default:
            return <></>
    }
}

interface TableHeaderProps {
    ordering?: string,
    setOrdering?: (value: string) => void
}

function ConsumerTVTableHeader({ ordering, setOrdering }: TableHeaderProps) {
    const { t } = useTranslation();

    return (
        <TableHeader>
            <TableHeaderColumn header="" field="" className="_checkbox" />
            <TableHeaderColumn header="ID" field="id" className="_id" ordering={ordering} setOrdering={setOrdering} />
            <TableHeaderColumn header={t('Provider')} field="company" className="_producer" ordering={ordering} setOrdering={setOrdering} />
            <TableHeaderColumn header={t('Content')} field="title" className="_content" ordering={ordering} setOrdering={setOrdering} />
            <TableHeaderColumn header={t('Subject')} className="_theme" />
            <TableHeaderColumn header="" className="_sources" />
            <TableHeaderColumn header="" className="_actions" />
        </TableHeader>
    );
}

function ProviderTVTableHeader({ ordering, setOrdering }: TableHeaderProps) {
    const role = useRole();
    const { t } = useTranslation();

    return (
        <TableHeader>
            <TableHeaderColumn header="ID" field="id" ordering={ordering} setOrdering={setOrdering} />
            <TableHeaderColumn header={t('Content')} field="title" ordering={ordering} setOrdering={setOrdering} />
            {role.label === ROLE.SITE_ADMIN && <TableHeaderColumn header={t('Provider')} field="company" ordering={ordering} setOrdering={setOrdering} />}
            <TableHeaderColumn header={<Tippy arrow={false} content={t('Count of orders')} placement="left"><Order className="table-list__header-label-main-icon" /></Tippy>} field="ar_cnt" ordering={ordering} setOrdering={setOrdering} />
            <TableHeaderColumn header={<Tippy arrow={false} content={t('Availability')} placement="left"><StatusViewAll className="table-list__header-label-main-icon" /></Tippy>} field="view_access" ordering={ordering} setOrdering={setOrdering} />
            {role.label === ROLE.SITE_MODERATOR ?
                <TableHeaderColumn header={t('Fill in')} field="moderated" ordering={ordering} setOrdering={setOrdering} />
                :
                <TableHeaderColumn header={t('Filling')} field="moderated" ordering={ordering} setOrdering={setOrdering} />
            }
            <TableHeaderColumn header="" className="_sources" />
            <TableHeaderColumn header="" className="_actions" />
        </TableHeader>
    );
}

function ConsumerTableHeader({ ordering, setOrdering }: TableHeaderProps) {
    const { t } = useTranslation();

    return (
        <TableHeader>
            <TableHeaderColumn header="ID" field="id" ordering={ordering} setOrdering={setOrdering} />
            <TableHeaderColumn header={t('Provider')} field="company" ordering={ordering} setOrdering={setOrdering} />
            <TableHeaderColumn header={t('Content')} field="title" ordering={ordering} setOrdering={setOrdering} />
            <TableHeaderColumn header="" className="_sources" />
            <TableHeaderColumn header="" className="_actions" />
            {/* <TableHeaderColumn header={<StatusProcuderOkText height={'14px'} />} title={'Проверено'} field="moderated" ordering={ordering} setOrdering={setOrdering} /> */}
            <TableHeaderColumn header={t('Checked')} title={t('Checked')} field="moderated" ordering={ordering} setOrdering={setOrdering} />
        </TableHeader>
    );
}

function ProviderTableHeader({ ordering, setOrdering }: TableHeaderProps) {
    const role = useRole();
    const { t } = useTranslation();

    return (
        <TableHeader>
            <TableHeaderColumn header="ID" field="id" ordering={ordering} setOrdering={setOrdering} />
            <TableHeaderColumn header={t('Content')} field="title" ordering={ordering} setOrdering={setOrdering} />
            {role.label === ROLE.SITE_ADMIN && <TableHeaderColumn header={t('Provider')} field="company" ordering={ordering} setOrdering={setOrdering} />}
            <TableHeaderColumn header={<Tippy arrow={false} content={t('Count of orders')} placement="left"><Order className="table-list__header-label-main-icon" /></Tippy>} field="ar_cnt" ordering={ordering} setOrdering={setOrdering} />
            <TableHeaderColumn header={<Tippy arrow={false} content={t('Count of downloads')} placement="left"><StatusDl className="table-list__header-label-main-icon" /></Tippy>} field="downloads_cnt" ordering={ordering} setOrdering={setOrdering} />
            {role.label !== ROLE.SITE_MODERATOR &&
                <>
                    <TableHeaderColumn header={<Tippy arrow={false} content={t('Accessibility mode for view')} placement="left"><StatusViewAll className="table-list__header-label-main-icon" /></Tippy>} field="view_access" ordering={ordering} setOrdering={setOrdering} />
                    <TableHeaderColumn header={<Tippy arrow={false} content={t('Accessibility mode for download')} placement="left"><Download className="table-list__header-label-main-icon" /></Tippy>} field="download_access" ordering={ordering} setOrdering={setOrdering} />
                </>
            }
            {role.label === ROLE.SITE_MODERATOR ?
                <TableHeaderColumn header={t('Fill in')} field="moderated" ordering={ordering} setOrdering={setOrdering} />
                :
                <TableHeaderColumn header={t('Filling')} field="moderated" ordering={ordering} setOrdering={setOrdering} />
            }
            <TableHeaderColumn header="" className="_sources" />
            <TableHeaderColumn header="" className="_actions" />
        </TableHeader>
    );
}

interface ConsumerGridItemProps {
    unit: ContentUnit,
    access: Record<number, AccessRequestStatus>,
}

export function ConsumerGridItem({ unit }: ConsumerGridItemProps) {
    const isGuest = useIsGuest();
    const [mediafilesRequest] = useLazyGetContentUnitMediaQuery();
    const [getMetaData] = useGetMetaDataMutation();
    const [getHeader] = useGetMediaHeaderMutation();
    const [accessRequest] = useAccessRequestUnitMutation();
    const lang = useLanguage();
    const auth = useAuth();
    const { t } = useTranslation();

    const downloadPermission = unit.permissions?.includes(PERMISSIONS.DOWNLOAD);
    const [error, setError] = useState<string>('');
    const [errorTitle, setErrorTitle] = useState<string>('');

    function getTitle(row: ContentUnit) {
        let tmp = lang === 'ru' ? row.title : row.title_eng;
        if (!tmp) {
            tmp = lang === 'ru' ? row.title_eng : row.title;
        }
        return tmp;
    }

    return (
        <div className="catalog-grid__item">
            <ErrorModal isOpen={!!error} onClose={() => setError('')} content={error} title={errorTitle} />

            <div className="catalog-card">
                <div className="catalog-card__id">ID {unit.id}</div>
                <div className="catalog-card__controls">
                    {unit.moderated === true &&
                        <div className="catalog-card__controls-action" title={t('Checked')}><StatusProcuderOk /></div>
                    }
                    {downloadPermission ?
                        <div className="catalog-card__controls-action" title={t('Download')}>
                            <Download />
                        </div>
                        :
                        (!unit.accreq.length &&
                            <div className="catalog-card__controls-action" title={t('Order')}>
                                <Order />
                            </div>)
                    }
                    {unit.offered &&
                        <div className="catalog-card__controls-status" title={t('In favorites')}>
                            <Fav />
                        </div>
                    }
                    {unit.new &&
                        <div className="catalog-card__controls-status" title={t('New')}>
                            <New />
                        </div>
                    }
                </div>
                {isGuest ?
                    <span className={'catalog-card__image' + (unit.covers?.at(0) ? '' : ' _empty')}>
                        {unit.covers?.at(0) && <ImageLoader url={unit.covers?.at(0)?.url} />}
                    </span>
                    :
                    <Link to={`/content/view/${unit.id}`} className={'catalog-card__image' + (unit.covers?.at(0) ? '' : ' _empty')}>
                        {unit.covers?.at(0) && <ImageLoader url={unit.covers?.at(0)?.url} />}
                    </Link>
                }
                <div className="catalog-card__body">
                    <div className="catalog-card__producer">
                        {unit.title}
                    </div>
                    <div
                        className="catalog-card__name"
                        title={unit.title}
                    // style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
                    >
                        {isGuest ?
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            <span>{(unit as any)?.tvthemes?.map((th: any) => th.name).join(' · ')}</span>
                            :
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            <Link to={`/content/view/${unit.id}`}>{(unit as any)?.tvthemes?.map((th: any) => th.name).join(' · ')}</Link>
                        }
                    </div>
                </div>
                <div className="catalog-card__info">
                    <div className="catalog-card__info-inner">
                        <div className="content-item__info-owner">{unit.owner?.name}</div>
                        <ContentItemInfo unit={unit} />
                        {!isGuest && <>
                            {downloadPermission ?
                                <div className="content-item__cta">
                                    <a href="#download" className="btn _min" onClick={(e) => {
                                        e.preventDefault();
                                        mediafilesRequest(Number(unit.id)).unwrap().then((data) => {
                                            getMetaData({ id: unit.id as number }).unwrap()
                                                .then((metaData) => {
                                                    const filename = getTitle(unit);
                                                    saveAs(metaData, `${filename}.zip`);
                                                })
                                                .catch(err => {
                                                    setErrorTitle(t('Metadata download error'));
                                                    setError(extractErrorDetail(err));
                                                });
                                            if (!!data.results.mediafiles?.length) {
                                                data.results.mediafiles?.forEach(f => {
                                                    getHeader(BASE_URL.substring(0, BASE_URL.length - 1) + f.url).then((d) => {
                                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                                        if ((d as any).error?.status === 418) {
                                                            alert(t('content:2FA_ERROR'));
                                                        } else {
                                                            window.open(BASE_URL.substring(0, BASE_URL.length - 1) + f.url);
                                                        }
                                                    }).catch((err) => {
                                                        if (err.status === 418) {
                                                            alert(t('content:2FA_ERROR'));
                                                        } else {
                                                            alert(extractErrorDetail(err));
                                                        }
                                                    });
                                                });
                                            }
                                        }).catch((err) => {
                                            setErrorTitle(t('Get mediafiles error'));
                                            setError(extractErrorDetail(err));
                                        });
                                    }}>
                                        <Trans>
                                            Download
                                        </Trans>
                                    </a>
                                    {/* <span className="btn _min _bd">Транскодировать</span> */}
                                </div>
                                :
                                <div className="content-item__cta">
                                    {!unit.accreq.length ?
                                        <a href="#buy" className="btn _min" onClick={(e) => {
                                            e.preventDefault();
                                            accessRequest({ unit: unit.id as number, sender: auth.account }).unwrap()
                                                .then(() => {
                                                    console.log(`Requested ${unit.id}`)
                                                }).catch(err => {
                                                    setErrorTitle(t('Order error'));
                                                    setError(extractErrorDetail(err));
                                                })
                                        }}><Trans>Order</Trans></a>
                                        :
                                        statusToBadge(unit.accreq)
                                    }
                                </div>
                            }
                        </>}
                    </div>
                </div>
            </div>
        </div>
    );
}

interface ConsumerTVGridItemProps {
    unit: ContentTVUnit,
    access: Record<number, AccessRequestStatus>,
    onOrder: (unit: ContentTVUnit) => void
}

export function ConsumerTVGridItem({ unit, onOrder }: ConsumerTVGridItemProps) {
    const isGuest = useIsGuest();
    const [mediafilesRequest] = useLazyGetContentUnitMediaQuery();
    const [getMetaData] = useGetMetaDataMutation();
    const [getHeader] = useGetMediaHeaderMutation();
    const lang = useLanguage();
    const { t } = useTranslation();

    const downloadPermission = unit.permissions?.includes(PERMISSIONS.DOWNLOAD);
    const [error, setError] = useState<string>('');
    const [errorTitle, setErrorTitle] = useState<string>('');

    function getTitle(row: ContentTVUnit) {
        let tmp = lang === 'ru' ? row.title : row.title_eng;
        if (!tmp) {
            tmp = lang === 'ru' ? row.title_eng : row.title;
        }
        return tmp;
    }

    return (
        <div className="catalog-grid__item">
            <ErrorModal isOpen={!!error} onClose={() => setError('')} content={error} title={errorTitle} />

            <div className="catalog-card">
                <div className="catalog-card__id">ID {unit.id}</div>
                <div className="catalog-card__controls">
                    {unit.moderated === true &&
                        <div className="catalog-card__controls-action" title={t('Checked')}><StatusProcuderOk /></div>
                    }
                    {downloadPermission ?
                        <div className="catalog-card__controls-action" title={t('Download')}>
                            <Download />
                        </div>
                        :
                        (!unit.accreq.length &&
                            <div className="catalog-card__controls-action" title={t('Order')}>
                                <Order />
                            </div>)
                    }
                    {unit.offered &&
                        <div className="catalog-card__controls-status" title={t('In favorites')}>
                            <Fav />
                        </div>
                    }
                    {unit.new &&
                        <div className="catalog-card__controls-status" title={t('New')}>
                            <New />
                        </div>
                    }
                </div>
                {isGuest ?
                    <span className={'catalog-card__image' + (unit.covers?.at(0) ? '' : ' _empty')}>
                        {unit.covers?.at(0) && <ImageLoader url={unit.covers?.at(0)?.url} />}
                    </span>
                    :
                    <Link to={`/content/view/${unit.id}`} className={'catalog-card__image' + (unit.covers?.at(0) ? '' : ' _empty')}>
                        {unit.covers?.at(0) && <ImageLoader url={unit.covers?.at(0)?.url} />}
                    </Link>
                }
                <div className="catalog-card__body">
                    <div className="catalog-card__producer">
                        {unit.title}
                    </div>
                    <div
                        className="catalog-card__name"
                        title={unit.title}
                    // style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
                    >
                        {isGuest ?
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            <span>{(unit as any)?.tvthemes?.map((th: any) => th.name).join(' · ')}</span>
                            :
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            <Link to={`/content/view/${unit.id}`}>{(unit as any)?.tvthemes.map((th: any) => th.name).join(' · ')}</Link>
                        }
                    </div>
                </div>
                <div className="catalog-card__info">
                    <div className="catalog-card__info-inner">
                        <div className="content-item__info-owner">{unit.owner?.name}</div>
                        <ContentItemInfo unit={unit} />
                        {!isGuest && <>
                            {downloadPermission ?
                                <div className="content-item__cta">
                                    <a href="#download" className="btn _min" onClick={(e) => {
                                        e.preventDefault();
                                        mediafilesRequest(Number(unit.id)).unwrap().then((data) => {
                                            getMetaData({ id: unit.id as number }).unwrap()
                                                .then((metaData) => {
                                                    const filename = getTitle(unit);
                                                    saveAs(metaData, `${filename}.zip`);
                                                })
                                                .catch(err => {
                                                    setErrorTitle(t('Metadata download error'));
                                                    setError(extractErrorDetail(err));
                                                });
                                            if (!!data.results.mediafiles?.length) {
                                                data.results.mediafiles?.forEach(f => {
                                                    getHeader(BASE_URL.substring(0, BASE_URL.length - 1) + f.url).then((d) => {
                                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                                        if ((d as any).error?.status === 418) {
                                                            alert(t('content:2FA_ERROR'));
                                                        } else {
                                                            window.open(BASE_URL.substring(0, BASE_URL.length - 1) + f.url);
                                                        }
                                                    }).catch((err) => {
                                                        if (err.status === 418) {
                                                            alert(t('content:2FA_ERROR'));
                                                        } else {
                                                            alert(extractErrorDetail(err));
                                                        }
                                                    });
                                                });
                                            }
                                        }).catch((err) => {
                                            setErrorTitle(t('Get mediafiles error'));
                                            setError(extractErrorDetail(err));
                                        });
                                    }}>
                                        <Trans>
                                            Download
                                        </Trans>
                                    </a>
                                </div>
                                :
                                <div className="content-item__cta">
                                    <a href="#buy" className="btn _min" onClick={(e) => {
                                        e.preventDefault();
                                        onOrder(unit);
                                        // accessRequest({ id: unit.id as number }).unwrap()
                                        //     .then(() => {
                                        //         console.log(`Requested ${unit.id}`)
                                        //     }).catch(err => {
                                        //         setErrorTitle(t('Order error'));
                                        //         setError(extractErrorDetail(err));
                                        //     })
                                    }}><Trans>Order</Trans></a>
                                    {!!unit.active_perm ?
                                        <span className="status-ok">
                                            <Trans>Permited</Trans>
                                        </span>
                                        :
                                        !!unit.accreq?.length && <span style={{ lineHeight: '32px', paddingLeft: '4px' }}>
                                            <span className="status-ok">
                                                <Trans>Ordered</Trans>
                                            </span>
                                        </span>
                                    }
                                </div>
                            }
                        </>}
                    </div>
                </div>
            </div>
        </div>
    );
}

interface ProviderGridItemProps {
    unit: ContentUnit | ContentTVUnit
}

function ProviderGridItem({ unit }: ProviderGridItemProps) {
    const accsessPermission = unit.view_access;
    const role = useRole();
    const { t } = useTranslation();

    const [showSendModal, setShowSendModal] = useState(false);

    return (
        <div className="catalog-grid__item">
            <SendModal isOpen={showSendModal} onClose={() => setShowSendModal(false)} unitId={unit.id as number} unitTitle={unit.title} />
            <div className="catalog-card">
                <div className="catalog-card__id">ID {unit.id}</div>
                <div className="catalog-card__controls">
                    {unit.typ === TYPS.CENSORED &&
                        <div className="catalog-card__controls-action" style={{ fontWeight: 700, color: 'red' }} title={t('Blocked by moderator')}>BANED</div>
                    }
                    {unit.autofill ?
                        // TODO следующий релиз 
                        <div className="catalog-card__controls-action" /*title="На проверке"*/><StatusProcuderEdit /></div>
                        :
                        <>
                            {unit.moderated === true &&
                                <div className="catalog-card__controls-action" title={t('Checked')}><StatusProcuderOk /></div>
                            }
                            {!unit.moderated &&
                                <div className="catalog-card__controls-action" title={t('Filled out')}><StatusProcuderPendind /></div>
                            }
                        </>
                    }
                    {accsessPermission === ACCESS_TYPES.NOBODY &&
                        <div className="catalog-card__controls-action" title={t('Access denided')}><StatusProcuderHidden /></div>
                        // <div className="catalog-card__controls-status" title="Доступно закрыт"><StatusViewNone /></div>
                    }
                    {accsessPermission === ACCESS_TYPES.LIST &&
                        <div className="catalog-card__controls-action" title={t('Available to group')}><StatusProcuderUsers /></div>
                        // <div className="catalog-card__controls-status" title="Доступно группе"><StatusViewList /></div>
                    }
                    {accsessPermission === ACCESS_TYPES.ALL &&
                        <div className="catalog-card__controls-action" title={t('Available to everyone')}><StatusProcuderVisible /></div>
                        // <div className="catalog-card__controls-status" title="Доступно всем"><StatusViewAll /></div>
                    }
                    {accsessPermission === ACCESS_TYPES.FAVORITES &&
                        <div className="catalog-card__controls-action" title={t('Available to VIP')}><StatusProcuderVip /></div>
                        // <div className="catalog-card__controls-status _vip" title="Доступно VIP">VIP</div>
                    }
                </div>
                <Link to={`/content/${unit.ctype === ContentType.TV ? 'tv' : 'media'}/${unit.id}`} className={'catalog-card__image'}>
                    {unit.covers?.at(0) ? <ImageLoader url={unit.covers?.at(0)?.url} /> : <img src={EmptyPng} alt="" />}
                </Link>
                <div className="catalog-card__body">
                    <div
                        className="catalog-card__name"
                        title={unit.title}
                    // style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
                    >
                        <Link to={`/content/${unit.ctype === ContentType.TV ? 'tv' : 'media'}/${unit.id}`}>{unit.title}</Link>
                    </div>
                </div>
                <div className="catalog-card__info">
                    <div className="catalog-card__info-inner">
                        <ContentItemInfo unit={unit} />
                        <div className="content-item__cta">
                            {/* <span className="btn _min _bd">Транскодировать</span> */}
                            {role.label !== ROLE.SITE_MODERATOR && unit.ctype === ContentType.UNIT && <div className="content-item__cta">
                                {/* <span className="btn _min _bd">Транскодировать</span> */}
                                <a href="#send" className="btn _min" onClick={(e) => {
                                    e.preventDefault();
                                    setShowSendModal(true);
                                }}>
                                    <Trans>
                                        Send
                                    </Trans>
                                </a>
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

interface ConsumerTableRowProps {
    unit: ContentUnit,
    access: Record<number, AccessRequestStatus>
}

function ConsumerTableRow({ unit }: ConsumerTableRowProps) {
    const auth = useAuth();
    const isGuest = useIsGuest();
    const [mediafilesRequest] = useLazyGetContentUnitMediaQuery();
    const [accessRequest] = useAccessRequestUnitMutation();
    const [getMetaData] = useGetMetaDataMutation();
    const [getHeader] = useGetMediaHeaderMutation();

    const lang = useLanguage();
    const { t } = useTranslation();

    const [error, setError] = useState<string>('');
    const [errorTitle, setErrorTitle] = useState<string>('');

    const downloadPermission = unit.permissions?.includes(PERMISSIONS.DOWNLOAD);

    function getTitle(row: ContentUnit) {
        let tmp = lang === 'ru' ? row.title : row.title_eng;
        if (!tmp) {
            tmp = lang === 'ru' ? row.title_eng : row.title;
        }
        return tmp;
    }

    return (
        <TableRow>
            <ErrorModal isOpen={!!error} onClose={() => setError('')} content={error} title={errorTitle} />

            <TableColumn className="_id">{unit.id}</TableColumn>
            <TableColumn className="_producer">
                <span className="catalog-list__producer">
                    {unit.offered ? <Fav /> : (unit.new ? <New /> : null)}
                    {unit.owner?.name}
                </span>
            </TableColumn>
            <TableColumn className="_content">
                <TableListName link={`/content/view/${unit.id}`} title={unit.title} url={unit.covers?.at(0)?.url} />
            </TableColumn>
            <TableColumn className="_sources">
                <ContentItemInfo unit={unit} dotted />
            </TableColumn>
            <TableColumn className="_actions">
                {!isGuest &&
                    <div className="catalog-list__info">
                        {downloadPermission ?
                            <div className="content-item__cta">
                                {/* поскольку метаданные должны быть всегда, не ругаемся на пустой список медиафайлов */}
                                <a href="#download" className="btn _min" onClick={(e) => {
                                    e.preventDefault();
                                    mediafilesRequest(Number(unit.id)).unwrap().then((data) => {
                                        getMetaData({ id: unit.id as number }).unwrap()
                                            .then((metaData) => {
                                                const filename = getTitle(unit);
                                                saveAs(metaData, `${filename}.zip`);
                                            })
                                            .catch(err => {
                                                setErrorTitle(t('Metadata download error'));
                                                setError(extractErrorDetail(err));
                                            })

                                        if (!!data.results.mediafiles?.length) {
                                            data.results.mediafiles?.forEach(f => {
                                                getHeader(BASE_URL.substring(0, BASE_URL.length - 1) + f.url).then((d) => {
                                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                                    if ((d as any).error?.status === 418) {
                                                        alert(t('content:2FA_ERROR'));
                                                    } else {
                                                        window.open(BASE_URL.substring(0, BASE_URL.length - 1) + f.url);
                                                    }
                                                }).catch((err) => {
                                                    if (err.status === 418) {
                                                        alert(t('content:2FA_ERROR'));
                                                    } else {
                                                        alert(extractErrorDetail(err));
                                                    }
                                                });
                                            });
                                        }
                                    }).catch((err) => {
                                        setErrorTitle(t('Get mediafile error'));
                                        setError(extractErrorDetail(err));
                                    });
                                }}><Trans>Download</Trans></a>
                                {/* <span className="btn _min _bd">Транскодировать</span> */}
                            </div>
                            :
                            <div className="content-item__cta">
                                {!unit.accreq.length ?
                                    <a href="#buy" className="btn _bd _min" onClick={(e) => {
                                        e.preventDefault();
                                        accessRequest({
                                            unit: unit.id as number,
                                            sender: auth.account,
                                        }).unwrap().then(() => {
                                            console.log(`Requested ${unit.id}`)
                                        }).catch((err) => {
                                            setErrorTitle(t('Order error'));
                                            setError(extractErrorDetail(err));
                                        })
                                    }}>
                                        <Trans>Order</Trans>
                                    </a>
                                    :
                                    statusToBadge(unit.accreq)
                                }
                            </div>
                        }
                    </div>
                }
            </TableColumn>
            <TableColumn className="_status" style={{ textAlign: 'center' }}>
                <span className={'entry-status-list__icon ' + (unit.moderated === true ? '_ok' : ' ')} style={{ display: 'inline-block' }}></span>
            </TableColumn>
        </TableRow>
    );
}

interface ProviderTableRowProps {
    unit: ContentUnit
}

function ProviderTableRow({ unit }: ProviderTableRowProps) {
    const { t } = useTranslation();

    const availPermissions = [
        { value: ACCESS_TYPES.ALL, label: t('All') },
        { value: ACCESS_TYPES.NOBODY, label: t('Nobody') },
        { value: ACCESS_TYPES.LIST, label: t('CUSTOM') },
        { value: ACCESS_TYPES.FAVORITES, label: 'VIP' },
    ]
    const [editRequest] = useEditContentUnitMutation();

    const [showSendModal, setShowSendModal] = useState(false);
    const role = useRole();

    const [error, setError] = useState<string>('');
    const [errorTitle] = useState<string>(t('Change permissions error'));

    function editView(value: ACCESS_TYPES, setErrorCallback: (v: string) => void) {
        editRequest({ id: unit.id, view_access: value }).unwrap()
            .catch((e) => setErrorCallback(extractErrorDetail(e)));
    }

    function editDownload(value: ACCESS_TYPES, setErrorCallback: (v: string) => void) {
        editRequest({ id: unit.id, download_access: value }).unwrap()
            .catch((e) => setErrorCallback(extractErrorDetail(e)));
    }

    return (
        <TableRow>
            <SendModal isOpen={showSendModal} onClose={() => setShowSendModal(false)} unitId={unit.id as number} unitTitle={unit.title} />
            <ErrorModal isOpen={!!error} onClose={() => setError('')} content={error} title={errorTitle} />

            <TableColumn className="_id">{unit.id}</TableColumn>
            <TableColumn className="_content">
                <TableListName link={`/content/media/${unit.id}`} title={unit.title} url={unit.covers?.at(0)?.url} >
                    <ContentItemInfo unit={unit} dotted />
                </TableListName>
            </TableColumn>
            {role.label === ROLE.SITE_ADMIN &&
                <TableColumn className="_prod">
                    {/* TODO VIP для поставщиков */}
                    {/* <span className="catalog-card__controls-status _min _vip" title="Доступно VIP">VIP</span> */}
                    {' '}
                    {unit?.owner?.name}
                </TableColumn>
            }
            <TableColumn className="_orders">
                {unit.ar_cnt}
            </TableColumn>
            <TableColumn className="_dl-status">
                {unit.downloads_cnt}
            </TableColumn>
            {role.label !== ROLE.SITE_MODERATOR &&
                <>
                    <Select minimized nobd options={availPermissions} value={unit.view_access} onChange={(v) => editView(v, setError)} className="table-list__col _view" />
                    <Select minimized nobd options={availPermissions} value={unit.download_access} onChange={(v) => editDownload(v, setError)} className="table-list__col _dl" />
                </>
            }
            <TableColumn className="_status">
                {unit.typ === TYPS.CENSORED ?
                    <span style={{ color: 'red', fontWeight: '500' }}><Trans>Lock</Trans></span>
                    :
                    (role.label === ROLE.SITE_MODERATOR ?
                        <span className={'entry-status-list__icon ' + (unit.autofill && '_edit')}></span>
                        :
                        <span className={'entry-status-list__icon ' + (unit.autofill ? '_edit' : (unit.moderated === true ? '_ok' : (unit.moderated === false ? '_rejected' : ' _pending')))}></span>
                    )
                }
            </TableColumn>
            <TableColumn className="_sources">
            </TableColumn>
            <TableColumn className="_actions">
                <div className="catalog-list__info">
                    {!isProvider(role.label) ?
                        <div className="catalog-list__teams">
                            {/* <span className="catalog-list__teams-item" style={{ backgroundColor: '#6932D4' }}>Команда</span>
                            <span className="catalog-list__teams-item" style={{ backgroundColor: '#323657' }}>Команда</span>
                            <span className="catalog-list__teams-item" style={{ backgroundColor: '#7AC689' }}>Команда</span>
                            <span className="catalog-list__teams-item" style={{ backgroundColor: '#EF5C69' }}>Команда</span>
                            <span className="catalog-list__teams-item" style={{ backgroundColor: '#447AD1' }}>Команда</span>
                            <span className="catalog-list__teams-item" style={{ backgroundColor: '#D48032' }}>Команда</span> */}
                        </div>
                        :
                        <div className="content-item__cta">
                            {/* <span className="btn _min _bd">Транскодировать</span> */}
                            <a href="#send" className="btn _min" onClick={(e) => {
                                e.preventDefault();
                                setShowSendModal(true);
                            }}>
                                <Trans>
                                    Send
                                </Trans>
                            </a>
                        </div>
                    }
                </div>
            </TableColumn>
        </TableRow>
    );
}

interface ConsumerTVTableRowProps {
    unit: ContentTVUnit,
    access: Record<number, AccessRequestStatus>,
    selection: Record<number, ContentTVUnit | null>,
    setSelection: Dispatch<SetStateAction<Record<number, ContentTVUnit | null>>>,
    showDialog: () => void,
}

function ConsumerTVTableRow({ unit, selection, setSelection, showDialog }: ConsumerTVTableRowProps) {
    const isGuest = useIsGuest();
    // const [accessRequest] = useAccessRequestTVMutation();

    // const auth = useAuth();
    // const { t } = useTranslation();

    // const [error, setError] = useState<string>('');
    // const [errorTitle, setErrorTitle] = useState<string>('');

    return (
        <TableRow>
            {/* <ErrorModal isOpen={!!error} onClose={() => setError('')} content={error} title={errorTitle} /> */}

            <TableColumn className="_checkbox">
                {!isGuest &&
                    <CheckBox
                        value={!!selection[unit.id]}
                        label={''}
                        onChange={(v) => setSelection((p) => {
                            const tmp = { ...p };
                            tmp[unit.id] = v ? unit : null;
                            return tmp;
                        })} />
                }
            </TableColumn>
            <TableColumn className="_id">{unit.id}</TableColumn>
            <TableColumn className="_producer">
                <span className="catalog-list__producer">
                    {unit.offered ? <Fav /> : (unit.new ? <New /> : null)}
                    {unit.owner?.name}
                </span>
            </TableColumn>
            <TableColumn className="_content">
                <TableListName link={`/content/view/${unit.id}`} title={unit.title} url={unit.covers?.at(0)?.url} />
            </TableColumn>
            <TableColumn className="_theme">{unit.tvthemes.map((th) => th.name).join(' · ')}</TableColumn>
            <TableColumn className="_sources">
                <ContentTVItemInfo unit={unit} dotted />
            </TableColumn>
            <TableColumn className="_actions">
                {!isGuest &&
                    <div className="catalog-list__info">
                        {
                            <div className="content-item__cta">
                                {unit.active_perm ?
                                    <span style={{ lineHeight: '32px', paddingLeft: '4px' }}>
                                        <span className="status-ok">
                                            <Trans>Permited</Trans>
                                        </span>
                                    </span>
                                    :
                                    !!unit.accreq?.length && <span style={{ lineHeight: '32px', paddingLeft: '4px' }}>
                                        <span className="status-ok">
                                            <Trans>Ordered</Trans>
                                        </span>
                                    </span>
                                }
                                <a href="#buy" className="btn _bd _min" onClick={(e) => {
                                    e.preventDefault();
                                    const tmp: Record<number, ContentTVUnit> = {};
                                    tmp[unit.id] = unit;
                                    setSelection(tmp);
                                    showDialog();
                                    // const accessRequestData = {
                                    //     units: [unit.id as number],
                                    //     sender: auth.account,
                                    //     details: {
                                    //         licagr: 1,
                                    //         pstype: 1,
                                    //         psdetails: '',
                                    //         additional: '',
                                    //         ontest: null
                                    //     }
                                    // };
                                    // accessRequest(accessRequestData).unwrap().then(() => {
                                    //     console.log(`Requested ${unit.id}`)
                                    // }).catch((err) => {
                                    //     setErrorTitle(t('Order error'));
                                    //     setError(extractErrorDetail(err));
                                    // })
                                }}><Trans>Order</Trans></a>
                            </div>
                        }
                    </div>
                }
            </TableColumn>
            <TableColumn className="_status" style={{ textAlign: 'center' }}>
                <span className={'entry-status-list__icon ' + (unit.moderated === true ? '_ok' : ' ')} style={{ display: 'inline-block' }}></span>
            </TableColumn>
        </TableRow>
    );
}

interface ProviderTVTableRowProps {
    unit: ContentTVUnit
}

function ProviderTVTableRow({ unit }: ProviderTVTableRowProps) {
    const { t } = useTranslation();

    const availPermissions = [
        { value: ACCESS_TYPES.ALL, label: t('All') },
        { value: ACCESS_TYPES.NOBODY, label: t('Nobody') },
        { value: ACCESS_TYPES.LIST, label: t('Group') },
        { value: ACCESS_TYPES.FAVORITES, label: 'VIP' },
    ]
    const [editRequest] = useEditTVUnitMutation();

    // const [showSendModal, setShowSendModal] = useState(false);
    const role = useRole();

    const [error, setError] = useState<string>('');
    const [errorTitle] = useState<string>(t('Change permissions error'));

    function editView(value: ACCESS_TYPES, setErrorCallback: (v: string) => void) {
        editRequest({ id: unit.id, view_access: value }).unwrap()
            .catch((e) => setErrorCallback(extractErrorDetail(e)));
    }

    return (
        <TableRow>
            {/* <SendModal isOpen={showSendModal} onClose={() => setShowSendModal(false)} unitId={unit.id as number} unitTitle={unit.title} /> */}
            <ErrorModal isOpen={!!error} onClose={() => setError('')} content={error} title={errorTitle} />

            <TableColumn className="_id">{unit.id}</TableColumn>
            <TableColumn className="_content">
                <TableListName link={`/content/tv/${unit.id}`} title={unit.title} url={unit.covers?.at(0)?.url} >
                    <ContentItemInfo unit={unit} dotted />
                </TableListName>
            </TableColumn>
            {role.label === ROLE.SITE_ADMIN &&
                <TableColumn className="_prod">
                    {/* TODO VIP для поставщиков */}
                    {/* <span className="catalog-card__controls-status _min _vip" title="Доступно VIP">VIP</span> */}
                    {' '}
                    {unit?.owner?.name}
                </TableColumn>
            }
            <TableColumn className="_orders">
                {unit.ar_cnt}
            </TableColumn>
            {role.label !== ROLE.SITE_MODERATOR &&
                <>
                    {unit.permissions.includes(PERMISSIONS.CHANGE) ?
                        <Select minimized nobd options={availPermissions} value={unit.view_access} onChange={(v) => editView(v, setError)} className="table-list__col _view" />
                        :
                        <TableColumn className="_orders">
                            {/* TODO отличие прав без редактирования */}
                        </TableColumn>
                    }
                </>
            }
            <TableColumn className="_status">
                {unit.typ === TYPS.CENSORED ?
                    <span style={{ color: 'red', fontWeight: '500' }}><Trans>Lock</Trans></span>
                    :
                    (role.label === ROLE.SITE_MODERATOR ?
                        <span className={'entry-status-list__icon ' + (unit.autofill && '_edit')}></span>
                        :
                        <span className={'entry-status-list__icon ' + (unit.autofill ? '_edit' : (unit.moderated === true ? '_ok' : (unit.moderated === false ? '_rejected' : ' _pending')))}></span>
                    )
                }
            </TableColumn>
            <TableColumn className="_sources">
            </TableColumn>
            <TableColumn className="_actions">
                <div className="catalog-list__info">
                    {!isProvider(role.label) ?
                        <div className="catalog-list__teams">
                            {/* <span className="catalog-list__teams-item" style={{ backgroundColor: '#6932D4' }}>Команда</span>
                            <span className="catalog-list__teams-item" style={{ backgroundColor: '#323657' }}>Команда</span>
                            <span className="catalog-list__teams-item" style={{ backgroundColor: '#7AC689' }}>Команда</span>
                            <span className="catalog-list__teams-item" style={{ backgroundColor: '#EF5C69' }}>Команда</span>
                            <span className="catalog-list__teams-item" style={{ backgroundColor: '#447AD1' }}>Команда</span>
                            <span className="catalog-list__teams-item" style={{ backgroundColor: '#D48032' }}>Команда</span> */}
                        </div>
                        :
                        <div className="content-item__cta">
                            {/* <span className="btn _min _bd">Транскодировать</span> */}
                            {/* <a href="#send" className="btn _min" onClick={(e) => {
                                e.preventDefault();
                                setShowSendModal(true);
                            }}>
                                <Trans>
                                    Send
                                </Trans>
                            </a> */}
                        </div>
                    }
                </div>
            </TableColumn>
        </TableRow>
    );
}

interface ContentUnitTableProps {
    showMode: SHOW_MODE
    usedBooks?: UsedBooks
    commonSearch: string
    setCommonSearch: (v: string) => void
    setNeibourCount: (v?: number) => void
}

function ContentUnitTable({ showMode, usedBooks, commonSearch, setCommonSearch, setNeibourCount }: ContentUnitTableProps) {
    const role = useRole();
    const auth = useAuth();
    const isGuest = useIsGuest();
    const isConsumer = useIsConsumer();
    const { t } = useTranslation();

    // const navigate = useNavigateSearch('/content/media');
    const [searchParams] = useSearchParams();

    const [data, setData] = useState<StatusPagesResponse<ContentUnit> | undefined>();

    const [refetch, { data: listData }] = useLazyGetContentUnitListQuery();
    const [refetchCount, { data: countData }] = useLazyGetContentTVListCountQuery();
    const [refetchNew, { data: newData }] = useLazyGetNewMediaQuery();
    const [refetchChecked, { data: checkedData }] = useLazyGetCheckedContentQuery();
    const [refetchOffer, { data: offerData }] = useLazyGetOffersMediaQuery();
    const { data: fullRequests } = useGetAccessRequestsQuery({ offset: 0, limit: -1 });

    const [current, setCurrent] = useState(0);
    const [restore, setRestore] = useState(true);
    const [scrollY, setScrollY] = useState(0);

    const [filterCount, setFilterCount] = useState<number>(0);
    const [params, setParams] = useState<Record<string, string>>({});
    const ignoreJump = useRef<boolean>(true);
    const [access, setAccess] = useState<Record<number, AccessRequestStatus>>({});

    const [isFetched, setIsFetched] = useState<boolean>(false);
    const [hasMore, setHasMore] = useState<boolean>(false);
    const [canDownload, setCanDownload] = useState<boolean>(false);
    const [sortType, setSortType] = useState<string>('date');
    const [availSortTypes] = useState<{ value: string; label: string; }[]>([
        { value: 'date', label: t('By date') },
        { value: 'name', label: t('By name') },
        { value: 'checked', label: t('By checked') }
    ]);

    const todayYear = new Date().getFullYear();
    const [availYears, setAvailYears] = useState<{ value: number; label: string; }[]>(
        Array.from(
            new Array(todayYear - 1905), (val, index) => todayYear - index).map((value) => ({ value, label: value.toString() })
            )
    );

    // const [commonSearch, setCommonSearch] = useState<string>('');
    const [contentYears, setContentYears] = useState<string[]>([]);
    const [contentRightAreasFilter, setContentRightAreasFilter] = useState<string[]>([]);
    const [contentRightCatsFilter, setContentRightCatsFilter] = useState<string[]>([]);
    const [contentTypesFilter, setContentTypesFilter] = useState<string[]>([]);
    const [contentQualities, setContentQualities] = useState<string[]>([]);
    const [contentGenres, setContentGenres] = useState<string[]>([]);
    const [contentLangs, setContentLangs] = useState<string[]>([]);
    const [contentCountries, setContentCountries] = useState<string[]>([]);
    const [contentCollections, setContentCollections] = useState<string[]>([]);
    const [contentTags, setContentTags] = useState<string[]>([]);
    // const [contentAccess, setContentAccess] = useState<string[]>([]);
    const [viewAccess, setViewAccess] = useState<number[]>([]);
    const [downloadAccess, setDownloadAccess] = useState<number[]>([]);
    // const [contentSubtitles, setContentSubtitles] = useState<string[]>([]);
    const [availContentRightAreas, setAvailContentRightAreas] = useState<{ value: string; label: string; }[]>([]);
    const [availContentRightCats, setAvailContentRightCats] = useState<{ value: string; label: string; }[]>([]);
    const [availContentTypes, setAvailContentTypes] = useState<{ value: string; label: string; }[]>([]);
    const [availQualities, setAvailQualities] = useState<{ value: string; label: string; }[]>([]);
    const [availGenres, setAvailGenres] = useState<{ value: string; label: string; }[]>([]);
    const [availLangs, setAvailLangs] = useState<{ value: string; label: string; }[]>([]);
    // const [availCountries, setAvailCountries] = useState<{ value: string; label: string; }[]>([]);
    const [availCollections, setAvailCollections] = useState<{ value: string; label: string; }[]>([]);
    // const [availSubtitles, setAvailSubtitles] = useState<{ value: string; label: string; }[]>([]);
    const [availTags, setAvailTags] = useState<{ value: string; label: string; }[]>([]);
    // const [availAccess] = useState<{ value: ACCESS_TYPES; label: string; }[]>([
    //     { value: ACCESS_TYPES.ALL, label: 'Для всех' },
    //     { value: ACCESS_TYPES.FAVORITES, label: 'VIP' }
    // ]);
    const [availProviderAccess] = useState<{ value: ACCESS_TYPES; label: string; }[]>([
        { value: ACCESS_TYPES.ALL, label: t('For all') },
        { value: ACCESS_TYPES.FAVORITES, label: t('For VIP') },
        { value: ACCESS_TYPES.LIST, label: t('For group') },
        { value: ACCESS_TYPES.NOBODY, label: t('For no one') },
    ]);

    const [filterVisible, setFilterVisible] = useState(false);

    const queryOrdering = searchParams.get('ordering');
    const defaultOrdering = role.label === ROLE.SITE_MODERATOR ? 'moderated' : 'id';
    const [ordering, setOrdering] = useState(queryOrdering || defaultOrdering);

    const [mainFilter, setMainFilter] = useState(isGuest ? 'new' : 'all');

    useEffect(() => {
        if (commonSearch) { refetchCount(commonSearch); }
    }, [commonSearch]);

    useEffect(() => {
        if (isGuest) {
            setMainFilter('new');
        }
    }, [isGuest]);

    const mainFilters = useMemo(() => [
        {
            value: 'all',
            label: t('All'),
            action: (p: OffsetLimit, onLoad: () => void) => {
                setIsFetched(true); refetch(p).unwrap().then(() => {
                    setIsFetched(false);
                    onLoad();
                }).catch(() => { setIsFetched(false); onLoad(); });
            },
            data: listData
        },
        { value: 'new', label: t('Novelty'), action: (p: OffsetLimit, onLoad: () => void) => { setIsFetched(true); refetchNew(p).unwrap().then(() => { setIsFetched(false); onLoad(); }).catch(() => { setIsFetched(false); onLoad(); }); }, data: newData },
        { value: 'checked', label: t('tv:STATUS_CHECKED'), action: (p: OffsetLimit, onLoad: () => void) => { setIsFetched(true); refetchChecked(p).unwrap().then(() => { setIsFetched(false); onLoad(); }).catch(() => { setIsFetched(false); onLoad(); }); }, data: checkedData },
        { value: 'offers', label: t('Offers'), counter: 0, action: (p: OffsetLimit, onLoad: () => void) => { setIsFetched(true); refetchOffer(p).unwrap().then(() => { setIsFetched(false); onLoad(); }).catch(() => { setIsFetched(false); onLoad(); }); }, data: offerData },
    ].filter((v) => v.value !== (isConsumer ? 'checked' : 'offers'))
        .filter((v) => role.label !== ROLE.GUEST_GUEST || v.value === 'new')
        .filter((v) => v.value !== 'checked' || role.label !== ROLE.SITE_MODERATOR)
        , [t, role.label, listData, newData, checkedData, offerData, refetch, refetchNew, refetchOffer]);

    useEffect(() => {
        if (!isMounted) {
            return;
        }
        if (!ignoreJump.current) {
            // navigate('/content/media', params);
        } else {
            ignoreJump.current = false;
        }
    }, [params]);

    useEffect(() => {
        setNeibourCount(countData?.results.count);
    }, [countData?.results]);

    useEffect(() => {
        setHasMore(!!data?.results.next);
    }, [data?.results]);

    const handleNavigation = useCallback(() => {
        if (!restore) {
            setScrollY(window.scrollY);
        }
        if ((document.body.scrollHeight - window.innerHeight) - window.scrollY < 300 && !isFetched) {
            if (hasMore) {
                setCurrent(data?.results.data.length || 0);
            }
        }
    }, [data?.results.data.length, hasMore, isFetched]);

    useEffect(() => {
        window.addEventListener('scroll', handleNavigation);

        return () => {
            window.removeEventListener('scroll', handleNavigation);
        };
    }, [handleNavigation]);

    useEffect(() => {
        const tmp = fullRequests?.results.data.reduce((acc, curr) => {
            const accessResponse = curr as AccessResponse;
            if (accessResponse.status !== AccessRequestStatus.GRANTED) {
                acc[accessResponse.id] = accessResponse.status;
            }
            return acc;
        }, {} as Record<number, AccessRequestStatus>);
        tmp && setAccess(tmp);
    }, [fullRequests]);

    const isMounted = useMounted();

    useEffect(() => {
        if (sortType === 'date') {
            setOrdering('id');
        } else if (sortType === 'name') {
            setOrdering('title');
        } else if (sortType === 'checked') {
            setOrdering('-moderated');
        }
    }, [sortType]);

    useEffect(() => {
        if (role.label === ROLE.SITE_MODERATOR) {
            setOrdering('moderated');
        }
    }, [role.label]);

    useEffect(() => {
        return () => {
            sessionStorage.contentListScrollPosition = scrollY;
            sessionStorage.contentListOffset = current;
        };
    }, [current, scrollY]);

    useEffect(() => {
        if (!isMounted) {
            return;
        }
        const oldParams: Record<string, string> = Object.keys(params).
            filter((key) => !(key.includes('offers') || key.includes('new') || key.includes('checked') || key.includes('all'))).
            reduce((cur, key) => { return Object.assign(cur, { [key]: params[key] }) }, {});
        oldParams[mainFilter] = '1';

        setParams(oldParams);
    }, [mainFilter]);

    useEffect(() => {
        if (!isMounted) {
            return;
        }
        if (auth.user) {
            setRestore(false);
            mainFilters.find(f => f.value === mainFilter)?.action(
                {
                    offset: current,
                    limit: restore ? (Number(sessionStorage.contentListOffset) + PAGE_SIZE) : PAGE_SIZE,
                    content_type: 'media',
                    ...params
                },
                () => sessionStorage.contentListScrollPosition && setTimeout(() => {
                    if (restore) {
                        window.scrollTo(0, Number(sessionStorage.contentListScrollPosition));
                    }
                    delete sessionStorage.contentListScrollPosition;
                    delete sessionStorage.contentListOffset;
                }, 25)
            );
            setData(mainFilters.find(f => f.value === mainFilter)?.data);
        }
        // eslint-disable-next-line
    }, [mainFilter, params, current]);

    useEffect(() => {
        let search = '';
        const rarea: string[] = [];
        const rcat: string[] = [];
        const unittype: string[] = [];
        const quality: string[] = [];
        const genre: string[] = [];
        const year: string[] = [];
        const language: string[] = [];
        const country: string[] = [];
        const view_access: string[] = [];
        const download_access: string[] = [];
        let downloadable = false;
        const tag: string[] = [];
        const collection: string[] = [];
        let order = '';

        const tmp: Record<string, string> = {};
        searchParams.forEach((v, k) => {
            switch (k) {
                case 'search': search = v; break;
                case 'rarea': rarea.push(v); break;
                case 'rcat': rcat.push(v); break;
                case 'unittype': unittype.push(v); break;
                case 'quality': quality.push(v); break;
                case 'genre': genre.push(v); break;
                case 'year': year.push(v); break;
                case 'language': language.push(v); break;
                case 'country': country.push(v); break;
                case 'view_access': view_access.push(v); break;
                case 'download_access': download_access.push(v); break;
                case 'downloadable': downloadable = Boolean(v); break;
                case 'tag': tag.push(v); break;
                case 'collection': collection.push(v); break;
                case 'ordering': order = v; break;
            }
            tmp[k] = v;
        });

        const oldParams = {
            search,
            rarea: rarea.join(','),
            rcat: rcat.join(','),
            unittype: unittype.join(','),
            quality: quality.join(','),
            genre: genre.join(','),
            year: year.join(','),
            language: language.join(','),
            country: country.join(','),
            view_access: view_access.join(','),
            download_access: download_access.join(','),
            downloadable: downloadable ? 'true' : '',
            tag: tag.join(','),
            collection: collection.join(','),
            ordering: order,
        };
        // setCommonSearch(search);

        // const oldParams = Object.keys(params).
        //     filter((key) => !(key.includes('offers') || key.includes('new') || key.includes('checked') || key.includes('all'))).
        //     reduce((cur, key) => { return Object.assign(cur, { [key]: params[key] }) }, {});

        if (tmp.offers === '1') {
            setMainFilter('offers');
            setParams(({ ...oldParams, offers: '1' }));
        } else if (tmp.new === '1') {
            setMainFilter('new');
            setParams(({ ...oldParams, new: '1' }));
        } else if (tmp.checked === '1') {
            setMainFilter('checked');
            setParams(({ ...oldParams, checked: '1' }));
        } else {
            setMainFilter(isGuest ? 'new' : 'all');
            setParams(({ ...oldParams }));
        }

        ignoreJump.current = true;

        // setCommonSearch(search);
        setContentRightAreasFilter(rarea);
        setContentRightCatsFilter(rcat);
        setContentTypesFilter(unittype);
        setContentQualities(quality);
        setContentGenres(genre);
        setContentYears(year);
        setContentLangs(language);
        setContentCountries(country);
        setViewAccess(view_access.map((n) => Number(n)));
        setDownloadAccess(download_access.map((n) => Number(n)));
        setContentTags(tag);
        setContentCollections(collection);
        setCanDownload(downloadable);
        setOrdering(order);
    }, [searchParams, isGuest]);

    useEffect(() => {
        if (!isMounted) {
            return;
        }

        setFilterCount(
            contentTypesFilter.length
            + contentRightAreasFilter.length
            + contentRightCatsFilter.length
            + contentYears.length
            + contentQualities.length
            + contentGenres.length
            + contentLangs.length
            + contentCountries.length
            + viewAccess.length
            + downloadAccess.length
            + contentCollections.length
            + contentTags.length
        );
        if (!ignoreJump.current) {
            setParams({
                search: commonSearch,
                rarea: contentRightAreasFilter.join(','),
                rcat: contentRightCatsFilter.join(','),
                unittype: contentTypesFilter.join(','),
                quality: contentQualities.join(','),
                genre: contentGenres.join(','),
                year: contentYears.join(','),
                language: contentLangs.join(','),
                country: contentCountries.join(','),
                view_access: viewAccess.join(','),
                download_access: downloadAccess.join(','),
                downloadable: canDownload ? 'true' : '',
                tag: contentTags.join(','),
                collection: contentCollections.join(','),
                ordering: ordering,
            });
        }

        setCurrent(0);
    }, [commonSearch, contentRightAreasFilter, contentRightCatsFilter, contentTypesFilter,
        contentQualities, contentGenres, contentLangs, contentCountries,
        viewAccess, downloadAccess, contentYears, ordering,
        canDownload, contentCollections.length, contentTags.length, contentCollections,
        contentTags
    ]);

    useEffect(() => {
        setAvailContentRightAreas(usedBooks?.rightsarea.map(g => ({ value: g, label: g })) || []);
        setAvailContentRightCats(usedBooks?.rightscat.map(g => ({ value: g, label: g })) || []);

        setAvailContentTypes(usedBooks?.utype.map(g => ({ value: g.id.toString(), label: (g.displayname || '') })) || []);
        setAvailQualities(usedBooks?.quality.map(g => ({ value: g.id.toString(), label: (g.displayname || '') })) || []);
        setAvailGenres(usedBooks?.genre.map(g => ({ value: g.id.toString(), label: (g.displayname || '') })) || []);
        setAvailLangs(usedBooks?.language.map(g => ({ value: g.id.toString(), label: (g.displayname || '') })) || []);

        // setAvailCountries(usedBooks?.results.country.map(g => ({ value: g.id, label: (g.terms[lang] || '') })) || []);
        setAvailCollections(usedBooks?.collection.map(g => ({ value: g, label: g })) || []);
        setAvailTags(usedBooks?.tag.map(g => ({ value: g, label: g })) || []);
        setAvailYears(usedBooks?.years.map(g => ({ value: g, label: g.toString() })) || []);
        // setAvailSubtitles(refBooks?.results.subtitle.map(g => ({value: g.id, label: (g.terms[lang] || '') })) || []);
    }, [usedBooks]);

    // useEffect(() => {
    //     setAvailTags(refTags?.results.map(g => ({ value: g, label: g })) || []);
    // }, [refTags]);

    useEffect(() => setData(listData), [listData]);
    useEffect(() => setData(offerData), [offerData]);
    useEffect(() => setData(newData), [newData]);
    useEffect(() => setData(checkedData), [checkedData]);

    return (
        <>
            <MainContentFilter>
                <SelectButton value={mainFilter} items={mainFilters} onChange={(v) => { setCurrent(0); setMainFilter(v); }} />

                <div className="main__controls">
                    <div className="main__controls-filter">
                        <Searcher value={commonSearch} onChange={(v) => setCommonSearch(v)} placeholder={t('Search by name and supplier')} />
                        <MultiSelect className="main__controls-filter-item" placeholder={t('Territory')} value={contentRightAreasFilter} options={availContentRightAreas} setValue={(v) => setContentRightAreasFilter(v)} minimized />
                        <MultiSelect className="main__controls-filter-item" placeholder={t('Category of rights')} value={contentRightCatsFilter} options={availContentRightCats} setValue={(v) => setContentRightCatsFilter(v)} minimized />
                        <MultiSelect className="main__controls-filter-item" placeholder={t('Category')} value={contentTypesFilter} options={availContentTypes} setValue={(v) => setContentTypesFilter(v)} minimized />
                        <MultiSelect className="main__controls-filter-item" placeholder={t('Quality')} value={contentQualities} options={availQualities} setValue={(v) => setContentQualities(v)} minimized />
                        <MultiSelect className="main__controls-filter-item" placeholder={t('Genre')} value={contentGenres} options={availGenres} setValue={(v) => setContentGenres(v)} minimized />
                        <MultiSelect className="main__controls-filter-item" placeholder={t('Language')} value={contentLangs} options={availLangs} setValue={(v) => setContentLangs(v)} minimized />
                        {/* лишнее */}
                        {/* <MultiSelect className="main__controls-filter-item" placeholder="Год выпуска" value={contentYears} options={availYears} setValue={(v) => setContentYears(v)} minimized />
        <MultiSelect className="main__controls-filter-item" placeholder="Страна" value={contentCountries} options={availCountries} setValue={(v) => setContentCountries(v)} minimized />
        <MultiSelect className="main__controls-filter-item" placeholder="Тэги" value={contentTags} options={availTags} setValue={(v) => setContentTags(v)} minimized /> */}
                        {/* TODO нужен ли все таки фильтр по доступам? */}
                        {/* <MultiSelect className="main__controls-filter-item" placeholder="Доступ" value={contentAccess} options={availAccess} setValue={(v) => setContentAccess(v)} minimized /> */}
                        {
                            isConsumer ?
                                <div className="main__controls-filter-item">
                                    <CheckBox value={canDownload} label={t('Can download')} onChange={(v) => setCanDownload(v)} />
                                </div>
                                :
                                <>
                                    {role.label !== ROLE.SITE_MODERATOR &&
                                        <>
                                            <MultiSelect className="main__controls-filter-item" placeholder={t('Can view')} value={viewAccess} options={availProviderAccess} setValue={(v) => setViewAccess(v)} minimized />
                                            <MultiSelect className="main__controls-filter-item" placeholder={t('Can downloads')} value={downloadAccess} options={availProviderAccess} setValue={(v) => setDownloadAccess(v)} minimized />
                                        </>
                                    }
                                </>
                        }
                        <MultiSelect className="main__controls-filter-item" placeholder={t('Collection')} value={contentCollections} options={availCollections} setValue={(v) => setContentCollections(v)} minimized />
                    </div>
                    {showMode === SHOW_MODE.GRID ?
                        <Select className={'main__controls-sort'} value={sortType} options={availSortTypes} onChange={(v) => setSortType(v)} nobd minimized />
                        :
                        <div style={{ height: '28px' }}>&nbsp;</div> // филлер чтобы не скакала кнопка фильтра
                    }
                    {/* будет показываться только для узких экранов - Mobile mode */}
                    <div className="main__controls-filter-trigger" onClick={() => setFilterVisible(!filterVisible)}>
                        <Filter />
                        {!!filterCount && <span className="main__controls-filter-trigger-counter">{filterCount}</span>}
                    </div>
                </div>
            </MainContentFilter>
            {showMode === SHOW_MODE.GRID ?
                <CatalogGrid>
                    {data?.results.data.map(unit => (
                        (isConsumer || isGuest) ?
                            <ConsumerGridItem key={unit.id} unit={unit} access={access} />
                            :
                            <ProviderGridItem key={unit.id} unit={unit} />
                    ))}
                </CatalogGrid>
                :
                (
                    <Table className={'catalog-list' + (isConsumer ? ' catalog-list__subscriber' : ' catalog-list-producer')}>
                        {(isConsumer || isGuest) ?
                            <ConsumerTableHeader setOrdering={setOrdering} ordering={ordering} />
                            :
                            <ProviderTableHeader setOrdering={setOrdering} ordering={ordering} />
                        }
                        <TableBody>
                            {data?.results.data.map(unit => (
                                (isConsumer || isGuest) ?
                                    <ConsumerTableRow key={unit.id} unit={unit} access={access} />
                                    :
                                    <ProviderTableRow key={unit.id} unit={unit} />
                            ))}
                        </TableBody>
                    </Table>)
            }
            {isFetched && <div className="w-full"><Spinner /></div>}
            <MobileFilter
                filterVisible={filterVisible}
                setFilterVisible={setFilterVisible}
                onClean={() => {
                    setContentTypesFilter([]);
                    setContentCountries([]);
                    setContentGenres([]);
                    setContentLangs([]);
                    setContentQualities([]);
                    setContentYears([]);
                }}
            >
                <MobileFilterItem label={t('Territory')} options={availContentRightAreas} value={contentRightAreasFilter} setValue={setContentRightAreasFilter} />
                <MobileFilterItem label={t('Category of rights')} options={availContentRightCats} value={contentRightCatsFilter} setValue={setContentRightCatsFilter} />
                <MobileFilterItem label={t('Category')} options={availContentTypes} value={contentTypesFilter} setValue={setContentTypesFilter} />
                <MobileFilterItem label={t('Quality')} options={availQualities} value={contentQualities} setValue={setContentQualities} />
                <MobileFilterItem label={t('Genre')} options={availGenres} value={contentGenres} setValue={setContentGenres} />
                <MobileFilterItem label={t('Language')} options={availLangs} value={contentLangs} setValue={setContentLangs} />
                <MobileFilterItem label={t('Year of issue')} options={availYears} value={contentYears} setValue={setContentYears} />
                <MobileFilterItem label={t('Tags')} options={availTags} value={contentTags} setValue={setContentTags} />
                {
                    isConsumer ?
                        null
                        :
                        <>
                            <MobileFilterItem label={t('Can view')} options={availProviderAccess} value={viewAccess} setValue={setViewAccess} />
                            <MobileFilterItem label={t('Can downloads')} options={availProviderAccess} value={downloadAccess} setValue={setDownloadAccess} />
                        </>
                }
                <MobileFilterItem label={t('Collection')} options={availCollections} value={contentCollections} setValue={setContentCollections} />
            </MobileFilter>
        </>
    )
}

interface ContentTVTableProps {
    showMode: SHOW_MODE
    setShowMode: (v: SHOW_MODE) => void
    usedBooks?: UsedBooks
    commonSearch: string
    setCommonSearch: (v: string) => void
    setNeibourCount: (v?: number) => void
}

function ContentTVTable({ showMode, setShowMode, usedBooks, commonSearch, setCommonSearch, setNeibourCount }: ContentTVTableProps) {
    const auth = useAuth();
    const { t } = useTranslation();
    const isGuest = useIsGuest();

    // const navigate = useNavigateSearch('/content/media');

    const role = useRole();
    const isConsumer = useIsConsumer();
    const isPartnerSource = useIsPartnerSource();

    const [searchParams] = useSearchParams();
    const [current, setCurrent] = useState(0);
    const [restore, setRestore] = useState(true);
    const [scrollY, setScrollY] = useState(0);

    const [filterCount, setFilterCount] = useState<number>(0);
    const [params, setParams] = useState<Record<string, string>>({});
    const ignoreJump = useRef<boolean>(true);
    const [access, setAccess] = useState<Record<number, AccessRequestStatus>>({});
    const [selection, setSelection] = useState<Record<number, ContentTVUnit | null>>({});
    const [showOrderDialog, setShowOrderDialog] = useState(false);

    const [isFetched, setIsFetched] = useState<boolean>(false);
    const [hasMore, setHasMore] = useState<boolean>(false);
    const [canDownload, setCanDownload] = useState<boolean>(false);
    const [sortType, setSortType] = useState<string>('date');
    const [availSortTypes] = useState<{ value: string; label: string; }[]>([
        { value: 'date', label: t('By date') },
        { value: 'name', label: t('By name') },
        { value: 'checked', label: t('By checked') }
    ]);

    // const [commonSearch, setCommonSearch] = useState<string>('');
    const [contentYears, setContentYears] = useState<string[]>([]);
    // const [contentRightAreasFilter, setContentRightAreasFilter] = useState<string[]>([]);
    const [contentCountryFilter, setContentCountryFilter] = useState<string[]>([]);
    const [contentRightCatsFilter, setContentRightCatsFilter] = useState<string[]>([]);
    const [contentTypesFilter, setContentTypesFilter] = useState<string[]>([]);
    const [contentQualities, setContentQualities] = useState<string[]>([]);
    const [contentTVThemes, setContentTVThemes] = useState<number[]>([]);
    const [contentLangs, setContentLangs] = useState<string[]>([]);
    // const [contentCountries, setContentCountries] = useState<string[]>([]);
    const [contentCollections, setContentCollections] = useState<string[]>([]);
    const [contentTags, setContentTags] = useState<string[]>([]);
    const [contentSources, setContentSources] = useState<string[]>([]);
    // const [contentAccess, setContentAccess] = useState<string[]>([]);
    const [viewAccess, setViewAccess] = useState<string[]>([]);
    const [downloadAccess, setDownloadAccess] = useState<string[]>([]);
    // const [contentSubtitles, setContentSubtitles] = useState<string[]>([]);
    // const [availContentRightAreas, setAvailContentRightAreas] = useState<{ value: string; label: string; }[]>([]);
    const [availQualities, setAvailQualities] = useState<{ value: string; label: string; }[]>([]);
    const [availTVThemes, setAvailTVThemes] = useState<{ value: number; label: string; }[]>([]);
    const [availLangs, setAvailLangs] = useState<{ value: string; label: string; }[]>([]);
    const [availCollections, setAvailCollections] = useState<{ value: string; label: string; }[]>([]);
    const [availCountries, setAvailCountries] = useState<{ value: number; label: string; }[]>([]);
    // const [availSubtitles, setAvailSubtitles] = useState<{ value: string; label: string; }[]>([]);
    // const [availAccess] = useState<{ value: ACCESS_TYPES; label: string; }[]>([
    //     { value: ACCESS_TYPES.ALL, label: 'Для всех' },
    //     { value: ACCESS_TYPES.FAVORITES, label: 'VIP' }
    // ]);
    const [availProviderAccess] = useState<{ value: ACCESS_TYPES; label: string; }[]>([
        { value: ACCESS_TYPES.ALL, label: t('For all') },
        { value: ACCESS_TYPES.FAVORITES, label: t('For VIP') },
        { value: ACCESS_TYPES.LIST, label: t('For group') },
        { value: ACCESS_TYPES.NOBODY, label: t('For no one') },
    ]);

    const [availSources] = useState<{ value: string; label: string; }[]>([
        { value: '1', label: t('tv:SATELLITE') },
        { value: '2', label: t('tv:LAND') },
        { value: '3', label: t('tv:MEDIALOGISTIC') },
        { value: '4', label: t('tv:OTHER_SOURCE') },
    ]);

    const [filterVisible, setFilterVisible] = useState(false);

    const queryOrdering = searchParams.get('ordering');
    const defaultOrdering = role.label === ROLE.SITE_MODERATOR ? 'moderated' : 'id';
    const [ordering, setOrdering] = useState(queryOrdering || defaultOrdering);

    const isMounted = useMounted();

    const [data, setData] = useState<StatusPagesResponse<ContentTVUnit> | undefined>();

    const [refetch, { data: listData }] = useLazyGetTVListQuery();
    const [refetchCount, { data: countData }] = useLazyGetContentUnitListCountQuery();
    const [refetchNew, { data: newData }] = useLazyGetNewTVQuery();
    const [refetchChecked, { data: checkedData }] = useLazyGetCheckedTVQuery();
    const [refetchOffer, { data: offerData }] = useLazyGetOffersTVQuery();
    const { data: fullRequests } = useGetAccessRequestsQuery({ offset: 0, limit: -1 });

    useEffect(() => ymHit('/content'), []);

    useEffect(() => {
        if (commonSearch) { refetchCount(commonSearch); }
    }, [commonSearch]);

    const [mainFilter, setMainFilter] = useState(isGuest ? 'new' : 'all');

    useEffect(() => {
        if (isGuest) {
            setMainFilter('new');
        }
    }, [isGuest]);

    const mainFilters = useMemo(() => [
        {
            value: 'all',
            label: t('All'),
            action: (p: OffsetLimit, onLoad: () => void) => {
                setIsFetched(true); refetch(p).unwrap().then(() => {
                    setIsFetched(false);
                    onLoad();
                }).catch(() => { setIsFetched(false); onLoad(); });
            },
            data: listData
        },
        { value: 'new', label: t('Novelty'), action: (p: OffsetLimit, onLoad: () => void) => { setIsFetched(true); refetchNew(p).unwrap().then(() => { setIsFetched(false); onLoad(); }).catch(() => { setIsFetched(false); onLoad(); }); }, data: newData },
        { value: 'checked', label: t('Checked'), action: (p: OffsetLimit, onLoad: () => void) => { setIsFetched(true); refetchChecked(p).unwrap().then(() => { setIsFetched(false); onLoad(); }).catch(() => { setIsFetched(false); onLoad(); }); }, data: checkedData },
        { value: 'offers', label: t('Offers'), counter: 0, action: (p: OffsetLimit, onLoad: () => void) => { setIsFetched(true); refetchOffer(p).unwrap().then(() => { setIsFetched(false); onLoad(); }).catch(() => { setIsFetched(false); onLoad(); }); }, data: offerData },
    ].filter((v) => v.value !== ((isConsumer || isPartnerSource) ? 'checked' : 'offers'))
        .filter((v) => role.label !== ROLE.GUEST_GUEST || v.value === 'new')
        .filter((v) => v.value !== 'checked' || role.label !== ROLE.SITE_MODERATOR)
        , [role.label, listData, newData, checkedData, offerData, refetch, refetchNew, refetchOffer]);

    useEffect(() => {
        if (!isMounted) {
            return;
        }
        if (!ignoreJump.current) {
            // navigate('/content/media', params);
        } else {
            ignoreJump.current = false;
        }
    }, [params]);

    useEffect(() => {
        setNeibourCount(countData?.results.count);
    }, [countData?.results]);

    useEffect(() => {
        setHasMore(!!data?.results.next);
    }, [data?.results]);

    const handleNavigation = useCallback(() => {
        if (!restore) {
            setScrollY(window.scrollY);
        }
        if ((document.body.scrollHeight - window.innerHeight) - window.scrollY < 300 && !isFetched) {
            if (hasMore) {
                setCurrent(data?.results.data.length || 0);
            }
        }
    }, [data?.results.data.length, hasMore, isFetched, restore]);

    useEffect(() => {
        window.addEventListener('scroll', handleNavigation);

        return () => {
            window.removeEventListener('scroll', handleNavigation);
        };
    }, [handleNavigation]);

    useEffect(() => {
        const tmp = fullRequests?.results.data.reduce((acc, curr) => {
            const accessResponse = curr as AccessResponse;
            if (accessResponse.status !== AccessRequestStatus.GRANTED) {
                acc[accessResponse.id] = accessResponse.status;
            }
            return acc;
        }, {} as Record<number, AccessRequestStatus>);
        tmp && setAccess(tmp);
    }, [fullRequests]);

    useEffect(() => {
        if (sortType === 'date') {
            setOrdering('id');
        } else if (sortType === 'name') {
            setOrdering('title');
        } else if (sortType === 'checked') {
            setOrdering('-moderated');
        }
    }, [sortType]);

    useEffect(() => {
        if (role.label === ROLE.SITE_MODERATOR) {
            setOrdering('moderated');
        }
    }, [role.label]);

    // useEffect(() => {
    //     return () => {
    //         sessionStorage.contentListScrollPosition = scrollY;
    //         sessionStorage.contentListOffset = current;
    //     };
    // }, [current, scrollY]);

    useEffect(() => {
        if (!isMounted) {
            return;
        }
        const oldParams: Record<string, string> = Object.keys(params).
            filter((key) => !(key.includes('offers') || key.includes('new') || key.includes('checked') || key.includes('all'))).
            reduce((cur, key) => { return Object.assign(cur, { [key]: params[key] }) }, {});
        oldParams[mainFilter] = '1';

        setParams(oldParams);
    }, [mainFilter]);

    useEffect(() => {
        if (!isMounted) {
            return;
        }
        if (auth.user) {
            setRestore(false);
            mainFilters.find(f => f.value === mainFilter)?.action(
                {
                    offset: current,
                    limit: restore ? (Number(sessionStorage.contentListOffset) + PAGE_SIZE) : PAGE_SIZE,
                    content_type: 'media',
                    ...params
                },
                () => sessionStorage.contentListScrollPosition && setTimeout(() => {
                    if (restore) {
                        window.scrollTo(0, Number(sessionStorage.contentListScrollPosition));
                    }
                    delete sessionStorage.contentListScrollPosition;
                    delete sessionStorage.contentListOffset;
                }, 25)
            );
            setData(mainFilters.find(f => f.value === mainFilter)?.data);
        }
        // eslint-disable-next-line
    }, [mainFilter, params, current]);

    useEffect(() => {
        if (sortType === 'date') {
            setOrdering('id');
        } else if (sortType === 'name') {
            setOrdering('title');
        } else if (sortType === 'checked') {
            setOrdering('-moderated');
        }
    }, [sortType]);

    useEffect(() => {
        if (role.label === ROLE.SITE_MODERATOR) {
            setOrdering('moderated');
        }
    }, [role.label]);

    useEffect(() => {
        return () => {
            sessionStorage.contentListScrollPosition = scrollY;
            sessionStorage.contentListOffset = current;
        };
    }, [current, scrollY]);

    useEffect(() => {
        let search = '';
        // const rarea: string[] = [];
        const rcat: string[] = [];
        const unittype: string[] = [];
        const quality: string[] = [];
        const tvthemes: string[] = [];
        const year: string[] = [];
        const language: string[] = [];
        const country: string[] = [];
        const view_access: string[] = [];
        const download_access: string[] = [];
        let downloadable = false;
        const tag: string[] = [];
        const collection: string[] = [];
        let order = '';

        const tmp: Record<string, string> = {};
        searchParams.forEach((v, k) => {
            switch (k) {
                case 'search': search = v; break;
                // case 'rarea': rarea.push(v); break;
                case 'rcat': rcat.push(v); break;
                case 'unittype': unittype.push(v); break;
                case 'quality': quality.push(v); break;
                case 'tvthemes': tvthemes.push(v); break;
                case 'year': year.push(v); break;
                case 'language': language.push(v); break;
                case 'country': country.push(v); break;
                case 'view_access': view_access.push(v); break;
                case 'download_access': download_access.push(v); break;
                case 'downloadable': downloadable = Boolean(v); break;
                case 'tag': tag.push(v); break;
                case 'collection': collection.push(v); break;
                case 'ordering': order = v; break;
            }
            tmp[k] = v;
        });

        const oldParams = {
            search,
            // rarea: rarea.join(','),
            rcat: rcat.join(','),
            unittype: unittype.join(','),
            quality: quality.join(','),
            tvthemes: tvthemes.join(','),
            year: year.join(','),
            language: language.join(','),
            country: country.join(','),
            view_access: view_access.join(','),
            download_access: download_access.join(','),
            downloadable: downloadable ? 'true' : '',
            tag: tag.join(','),
            collection: collection.join(','),
            ordering: order,
        };
        // setCommonSearch(search);

        // const oldParams = Object.keys(params).
        //     filter((key) => !(key.includes('offers') || key.includes('new') || key.includes('checked') || key.includes('all'))).
        //     reduce((cur, key) => { return Object.assign(cur, { [key]: params[key] }) }, {});

        if (tmp.offers === '1') {
            setMainFilter('offers');
            setParams(({ ...oldParams, offers: '1' }));
        } else if (tmp.new === '1') {
            setMainFilter('new');
            setParams(({ ...oldParams, new: '1' }));
        } else if (tmp.checked === '1') {
            setMainFilter('checked');
            setParams(({ ...oldParams, checked: '1' }));
        } else {
            setMainFilter(isGuest ? 'new' : 'all');
            setParams(({ ...oldParams }));
        }

        ignoreJump.current = true;

        // setCommonSearch(search);
        setContentCountryFilter(country);
        setContentRightCatsFilter(rcat);
        setContentTypesFilter(unittype);
        setContentQualities(quality);
        setContentTVThemes(tvthemes.map((thm) => Number(thm)));
        setContentYears(year);
        setContentLangs(language);
        // setContentCountries(country);
        setViewAccess(view_access);
        setDownloadAccess(download_access);
        setContentTags(tag);
        setContentCollections(collection);
        setCanDownload(downloadable);
        setOrdering(order);
    }, [searchParams]);

    useEffect(() => {
        if (!isMounted) {
            return;
        }

        setFilterCount(
            contentTypesFilter.length
            + contentCountryFilter.length
            + contentRightCatsFilter.length
            + contentYears.length
            + contentQualities.length
            + contentTVThemes.length
            + contentLangs.length
            // + contentCountries.length
            + viewAccess.length
            + downloadAccess.length
            + contentCollections.length
            + contentTags.length
        );
        if (!ignoreJump.current) {
            setParams({
                search: commonSearch,
                country: contentCountryFilter.join(','),
                rcat: contentRightCatsFilter.join(','),
                unittype: contentTypesFilter.join(','),
                quality: contentQualities.join(','),
                tvtheme: contentTVThemes.join(','),
                year: contentYears.join(','),
                language: contentLangs.join(','),
                // country: contentCountries.join(','),
                view_access: viewAccess.join(','),
                download_access: downloadAccess.join(','),
                downloadable: canDownload ? 'true' : '',
                tag: contentTags.join(','),
                collection: contentCollections.join(','),
                tvsrctype: contentSources.join(','),
                ordering: ordering,
            });
        }

        setCurrent(0);
    }, [
        commonSearch, contentCountryFilter, contentRightCatsFilter, contentTypesFilter,
        contentQualities, contentTVThemes, contentLangs, viewAccess,
        downloadAccess, contentYears, ordering, canDownload,
        contentCollections.length, contentTags.length, contentCollections, contentTags
    ]);

    useEffect(() => {
        // setAvailContentRightAreas(usedBooks?.rightsarea?.map(g => ({ value: g, label: g })) || []);

        setAvailQualities(usedBooks?.tvquality.map(g => ({ value: g.id.toString(), label: (g.displayname || '') })) || []);
        setAvailTVThemes(usedBooks?.tvtheme.map(g => ({ value: g.id, label: (g.displayname || '') })) || []);
        setAvailLangs(usedBooks?.language.map(g => ({ value: g.id.toString(), label: (g.displayname || '') })) || []);

        setAvailCollections(usedBooks?.collection.map(g => ({ value: g, label: g })) || []);
        setAvailCountries(usedBooks?.country.map(g => ({ value: g.id, label: (g.displayname || '') })) || []);
        // setAvailSubtitles(refBooks?.results.subtitle.map(g => ({value: g.id, label: (g.terms[lang] || '') })) || []);
    }, [usedBooks]);

    // useEffect(() => {
    //     setAvailTags(refTags?.results.map(g => ({ value: g, label: g })) || []);
    // }, [refTags]);

    useEffect(() => setData(listData), [listData]);
    useEffect(() => setData(offerData), [offerData]);
    useEffect(() => setData(newData), [newData]);
    useEffect(() => setData(checkedData), [checkedData]);

    return (
        <>
            <ContentTVOrderModal
                tvChannels={Object.values(selection).filter(s => s !== null)}
                isOpen={showOrderDialog}
                onClose={() => { setShowOrderDialog(false); if (showMode === SHOW_MODE.GRID) { setSelection({}); } }}
                onSuccess={() => {
                    setSelection({});
                }}
            />
            <MainContentFilter>
                <SelectButton value={mainFilter} items={mainFilters} onChange={(v) => { setCurrent(0); setMainFilter(v); }} />

                <div className="main__controls">
                    <div className="main__controls-filter">
                        <Searcher value={commonSearch} onChange={(v) => setCommonSearch(v)} placeholder={t('Search by name and supplier')} />
                        <MultiSelect className="main__controls-filter-item" placeholder={t('Subject')} value={contentTVThemes} options={availTVThemes} setValue={(v) => setContentTVThemes(v)} minimized />
                        <MultiSelect className="main__controls-filter-item" placeholder={t('Quality')} value={contentQualities} options={availQualities} setValue={(v) => setContentQualities(v)} minimized />
                        <MultiSelect className="main__controls-filter-item" placeholder={t('Language')} value={contentLangs} options={availLangs} setValue={(v) => setContentLangs(v)} minimized />
                        <MultiSelect className="main__controls-filter-item" placeholder={t('Country')} value={contentCountryFilter} options={availCountries} setValue={(v) => setContentCountryFilter(v)} minimized />
                        {/* <MultiSelect className="main__controls-filter-item" placeholder="Доступ" value={contentAccess} options={availAccess} setValue={(v) => setContentAccess(v)} minimized /> */}
                        {
                            (isConsumer || isPartnerSource) ?
                                <div className="main__controls-filter-item">
                                    {/* <CheckBox value={canDownload} label={'Можно скачать'} onChange={(v) => setCanDownload(v)} /> */}
                                </div>
                                :
                                <>
                                    {role.label !== ROLE.SITE_MODERATOR &&
                                        <>
                                            <MultiSelect className="main__controls-filter-item" placeholder={t('Access')} value={viewAccess} options={availProviderAccess} setValue={(v) => setViewAccess(v)} minimized />
                                        </>
                                    }
                                </>
                        }
                        <MultiSelect className="main__controls-filter-item" placeholder={t('Source')} value={contentSources} options={availSources} setValue={(v) => setContentSources(v)} minimized />
                        <MultiSelect className="main__controls-filter-item" placeholder={t('Collection')} value={contentCollections} options={availCollections} setValue={(v) => setContentCollections(v)} minimized />
                    </div>
                    {showMode === SHOW_MODE.GRID ?
                        <Select className={'main__controls-sort'} value={sortType} options={availSortTypes} onChange={(v) => setSortType(v)} nobd minimized />
                        :
                        <div style={{ height: '28px' }}>&nbsp;</div> // филлер чтобы не скакала кнопка фильтра
                    }
                    {/* будет показываться только для узких экранов - Mobile mode */}
                    <div className="main__controls-filter-trigger" onClick={() => setFilterVisible(!filterVisible)}>
                        <Filter />
                        {!!filterCount && <span className="main__controls-filter-trigger-counter">{filterCount}</span>}
                    </div>
                </div>
            </MainContentFilter>
            {showMode === SHOW_MODE.GRID ?
                <CatalogGrid>
                    {data?.results.data.map(unit => (
                        (isConsumer || isGuest || isPartnerSource) ?
                            <ConsumerTVGridItem
                                key={unit.id}
                                unit={unit}
                                access={access}
                                onOrder={(u) => {
                                    const tmp: Record<number, ContentTVUnit> = {};
                                    tmp[u.id] = u;
                                    setSelection(tmp);
                                    setShowOrderDialog(true);
                                }}
                            />
                            :
                            <ProviderGridItem key={unit.id} unit={unit} />
                    ))}
                    {
                        document.getElementsByClassName('tv-content')[0] && isConsumer &&
                        ReactDOM.createPortal(
                            <div className="tv-content__bottom">
                                <Button onClick={() => setShowMode(SHOW_MODE.LIST)}><Trans>Order several</Trans></Button>
                            </div>, document.getElementsByClassName('tv-content')[0])
                    }
                </CatalogGrid>
                :
                (
                    <Table className={'catalog-list' + ((isConsumer || isPartnerSource) ? ' catalog-list__subscriber' : ' catalog-list-producer')}>
                        {(isConsumer || isGuest || isPartnerSource) ?
                            <ConsumerTVTableHeader setOrdering={setOrdering} ordering={ordering} />
                            :
                            <ProviderTVTableHeader setOrdering={setOrdering} ordering={ordering} />
                        }
                        <TableBody>
                            {data?.results.data.map(unit => (
                                (isConsumer || isGuest || isPartnerSource) ?
                                    <ConsumerTVTableRow key={unit.id} unit={unit} access={access} selection={selection} setSelection={setSelection} showDialog={() => setShowOrderDialog(true)} />
                                    :
                                    <ProviderTVTableRow key={unit.id} unit={unit} />
                            ))}
                        </TableBody>
                    </Table>)
            }
            {
                showMode === SHOW_MODE.LIST && !!Object.values(selection).filter((s) => s).length && document.getElementsByClassName('tv-content')[0] &&
                ReactDOM.createPortal(
                    <div className="tv-content__bottom _list _show">
                        <Button onClick={() => {
                            setShowOrderDialog(true);
                        }}>
                            <Trans>Order</Trans>
                            {' · '}
                            <span>{Object.values(selection).filter((s) => s).length}</span>
                        </Button>
                    </div>, document.getElementsByClassName('tv-content')[0])
            }
            <MobileFilter
                filterVisible={filterVisible}
                setFilterVisible={setFilterVisible}
                onClean={() => {
                    setContentTVThemes([]);
                    setContentCountryFilter([]);
                    setContentLangs([]);
                    setContentQualities([]);
                    setContentSources([]);
                    setViewAccess([]);
                }}
            >
                <MobileFilterItem label="Тематика" options={availTVThemes} value={contentTVThemes} setValue={setContentTVThemes} />
                <MobileFilterItem label="Страна" options={availCountries} value={contentCountryFilter} setValue={setContentCountryFilter} />
                <MobileFilterItem label="Качество" options={availQualities} value={contentQualities} setValue={setContentQualities} />
                <MobileFilterItem label="Язык" options={availLangs} value={contentLangs} setValue={setContentLangs} />
                {
                    (isConsumer || isPartnerSource) ?
                        null
                        :
                        <>
                            <MobileFilterItem label="Доступ" options={availProviderAccess} value={viewAccess} setValue={setViewAccess} />
                        </>
                }
                <MobileFilterItem label="Источник" options={availSources} value={contentSources} setValue={setContentSources} />
            </MobileFilter>
        </>
    )
}

export const useNavigateSearch = (defaultUrl?: string) => {
    const navigate = useNavigate();
    const [last, setLast] = useState(defaultUrl);

    return (pathname: string, params?: Record<string, string>) => {
        const localParams = params || {};
        const stringParams = `${Object.keys(localParams).filter(k => localParams[k]).filter(k => k !== 'all').map(k => localParams[k].toString().split(',').map(mk => k + '=' + mk).join('&')).join('&')}`;
        const fullPath = `${pathname}?${stringParams}`;
        if (last === fullPath) {
            return;
        }
        setLast(fullPath);
        navigate({ pathname, search: `?${createSearchParams(stringParams)}` });
    }
};

export function useMounted() {
    const [isMounted, setIsMounted] = useState(false)
    useEffect(() => {
        setIsMounted(true)
    }, [])
    return isMounted;
}

enum SHOW_MODE {
    GRID = 'grid',
    LIST = 'list',
}

interface ContentListPageProps {
    type?: 'tv' | 'media'
}

function ContentListPage({ type }: ContentListPageProps) {
    const isConsumer = useIsConsumer();
    const isPartnerSource = useIsPartnerSource();
    const { t } = useTranslation();

    // const { data: usedBooks } = useGetUsedBookQuery();
    const { data: tvUsedBooks } = useGetTVUsedBookQuery();
    const { data: mediaUsedBooks } = useGetMediaUsedBookQuery();

    const [tvCount, setTVCount] = useState<number | undefined>(0);
    const [unitCount, setUnitCount] = useState<number | undefined>(0);
    const [commonSearch, setCommonSearch] = useState<string>('');

    const [contentType, setContentType] = useState(type || localStorage.showContentType || 'tv');
    const [availContentType, setAvailContentType] = useState<{ value: string, label: string, counter?: number }[]>([
        { value: 'tv', label: t('content:TV'), counter: undefined },
        { value: 'media', label: t('content:MEDIA'), counter: undefined },
    ]);

    useEffect(() => {
        setAvailContentType([
            { value: 'tv', label: t('content:TV'), counter: contentType === 'tv' ? undefined : tvCount },
            { value: 'media', label: t('content:MEDIA'), counter: contentType !== 'tv' ? undefined : unitCount },
        ]);
    }, [t, tvCount, unitCount]);

    const [showMode, setShowMode] = useState(localStorage.showContentMode || SHOW_MODE.LIST);
    const showModes = [
        { value: SHOW_MODE.GRID, label: t('content:VIEW_GRID'), icon: <Grid /> },
        { value: SHOW_MODE.LIST, label: t('content:VIEW_LIST'), icon: <List /> },
    ]

    useEffect(() => {
        if (type) {
            setContentType(type);
            localStorage.showContentType = type;
        }
    }, [type]);

    useEffect(() => {
        document.title = `${t('Mediabaza')} - ${t('Catalog')}`;
    }, [t]);

    return (
        <ContentTV withoutWrapper={contentType !== 'tv'}>
            <Content>
                {(isConsumer || isPartnerSource) ?
                    <MainHeader icon={<HeadingCatalog />} label={t('Showcase')}>
                        <Switch value={showMode} items={showModes} onChange={(v) => { setShowMode(v); localStorage.showContentMode = v; }} />
                    </MainHeader>
                    :
                    <MainHeader icon={<HeadingCatalogProducer />} label={t('Catalog')}>
                        <Switch value={showMode} items={showModes} onChange={(v) => { setShowMode(v); localStorage.showContentMode = v; }} />
                    </MainHeader>
                }

                <MainContentFilter>
                    <SelectButton value={contentType} items={availContentType} onChange={(v) => { setContentType(v); localStorage.showContentType = v; }} bubble style={{ marginBottom: 0 }} />
                </MainContentFilter>
                {contentType === 'tv' ?
                    <ContentTVTable showMode={showMode} setShowMode={setShowMode} usedBooks={tvUsedBooks?.results} setNeibourCount={setUnitCount} commonSearch={commonSearch} setCommonSearch={setCommonSearch} />
                    :
                    <ContentUnitTable showMode={showMode} usedBooks={mediaUsedBooks?.results} setNeibourCount={setTVCount} commonSearch={commonSearch} setCommonSearch={setCommonSearch} />
                }
            </Content>
        </ContentTV>
    )
}

export default ContentListPage;
